export { IconStyled } from './icon.styled'
export type { RadixIcon } from './icon.styled'
